const ChevronDown = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.293 9.793L12 14.086L7.70697 9.793L6.29297 11.207L12 16.914L17.707 11.207L16.293 9.793Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default ChevronDown;
